import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, max, orderBy } from 'lodash';
import { lassoForm, Text, TextArea, Select, validator } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';

function validate(values) {
  const response = {
    firstName: null,
    lastName: null,
    email: null,
  };

  if (!values.firstName) {
    response.firstName = {
      error: 'First Name is required',
    };
  }

  if (!values.lastName) {
    response.lastName = {
      error: 'Last Name is required',
    };
  }

  if (!values.email) {
    response.email = {
      error: 'Email is required',
    };
  } else if (!validator.isEmail(values.email)) {
    response.email = {
      error: 'Email must be valid',
    };
  }

  return response;
}

class ServiceRequestForm extends React.Component {
  constructor(props) {
    super(props);

    const { formApi } = props;

    formApi.setValue('formName', 'serviceRequest');

    this.state = {
    };

    this.addDefect = this.addDefect.bind(this);
    this.removeDefect = this.removeDefect.bind(this);
  }

  addDefect(e) {
    e.preventDefault();

    const next = max(this.state.defects) + 1;
    this.setState({
      defects: [...this.state.defects, next],
    });
  }

  removeDefect(e, defect) {
    e.preventDefault();
    const defects = this.state.defects;
    defects.splice(defects.indexOf(defect), 1);

    this.setState({
      defects,
    });
  }

  render() {
    const { formApi, success, widget } = this.props;
    // const { defects } = this.state;

    function getError(field) {
      return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
    }

    function getErrorClass(field) {
      if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
        return 'is-invalid';
      }

      return null;
    }

    if (success) {
      return (
        <Redirect
          name="service-request-thank-you"
        />
      );
    }

    return (
      <div className="pb-5">
        <div className="form-row">
          <div className="col-md-6">
            <Text
              name="firstName"
              field="firstName"
              className={`form-control ${getErrorClass('firstName')}`}
              placeholder="First Name *"
            />
            <div className="invalid-feedback">
              {getError('firstName')}
            </div>
          </div>
          <div className="col-md-6">
            <Text
              name="lastName"
              field="lastName"
              className={`form-control ${getErrorClass('lastName')}`}
              placeholder="Last Name *"
            />
            <div className="invalid-feedback">
              {getError('lastName')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-4">
            <Text
              name="address"
              field="address"
              validate={value => (value ? null : 'Street Address is required')}
              className={`form-control ${getErrorClass('address')}`}
              placeholder="Street Address *"
            />
            <div className="invalid-feedback">
              {getError('address')}
            </div>
          </div>
          <div className="col-md-4">
            <Text
              name="city"
              field="city"
              validate={value => (value ? null : 'City is required')}
              className={`form-control ${getErrorClass('city')}`}
              placeholder="City *"
            />
            <div className="invalid-feedback">
              {getError('city')}
            </div>
          </div>
          <div className="col-md-2">
            <Text
              name="state"
              field="state"
              validate={value => (value ? null : 'State is required')}
              className={`form-control ${getErrorClass('state')}`}
              placeholder="State *"
            />
            <div className="invalid-feedback">
              {getError('state')}
            </div>
          </div>
          <div className="col-md-2">
            <Text
              name="zip"
              field="zip"
              validate={value => (value ? null : 'Zip is required')}
              className={`form-control ${getErrorClass('zip')}`}
              placeholder="Zip *"
            />
            <div className="invalid-feedback">
              {getError('zip')}
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-6">
            <Text
              name="phone"
              field="phone"
              validate={value => (value ? null : 'Phone is required')}
              className={`form-control ${getErrorClass('phone')}`}
              placeholder="Phone *"
            />
            <div className="invalid-feedback">
              {getError('phone')}
            </div>
          </div>
          <div className="col-md-6">
            <Text
              name="email"
              field="email"
              className={`form-control ${getErrorClass('email')}`}
              placeholder="Email Address *"
            />
            <div className="invalid-feedback">
              {getError('email')}
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="form-row">
            <div className="col-md-5 ml-auto">
              <Select
                className={`form-control ${getErrorClass('preferredContact')}`}
                style={{ padding: '10px' }}
                name="preferredContact"
                field="preferredContact"
                placeholder="Preferred Method of Contact"
                options={[
                  { label: 'Phone', value: 'phone' },
                  { label: 'Email', value: 'email' },
                ]}
              />
              <div className="invalid-feedback">
                {getError('preferredContact')}
              </div>
            </div>
            <div className="col-md-5 mr-auto">
              <Select
                className={`form-control ${getErrorClass('Community_Name')}`}
                name="Community_Name"
                style={{ padding: '10px' }}
                field="Community_Name"
                placeholder="Choose Community"
                options={orderBy(get(widget, 'community_form'), 'name', 'asc').map(community => ({ label: get(community, 'community'), value: get(community, 'community') }))}
              />
              <div className="invalid-feedback">
                {getError('Community_Name')}
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="col-12">
            <p className="text-left" />
          </div>
        </div>

        <div className="form-row">
          <div className="col">
            <TextArea
              name="comments"
              field="comments"
              className="form-control"
              placeholder="Questions/Comments"
              rows="4"
            />
          </div>
        </div>
        <input type="hidden" name="guid" value="" />
        <button type="submit" className="btn mt-4" disabled={formApi.submitted}>Submit Request</button>
      </div>
    );
  }
}

ServiceRequestForm.propTypes = {
  widget: PropTypes.object.isRequired,
  formApi: PropTypes.object.isRequired,
  success: PropTypes.object,
};

ServiceRequestForm.defaultProps = {
  success: undefined,
};

export default lassoForm({
  validate,
  defaultValues: {
    domainAccountId: 'LAS-396770-01',
    ProjectID: ['11622'],
  },
})(
  withData(
    {
      widget: 'service_request',
    },
  )(ServiceRequestForm),
);



// WEBPACK FOOTER //
// ./src/pages/ServiceRequest/ServiceRequestForm.js